module.exports = __webpack_public_path__ + "img/emp2-3.83426a5c.jpg";